import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {TreatmentDefinitionModel} from '../../../api/entity/treatmentDefinitionModel';

@Injectable({
    providedIn: 'root'
})
export class TreatmentDefinitionRepository extends AbstractRepositoryV2<TreatmentDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('TreatmentDefinition', serviceElementsFactory, injector);
    }
}
